import * as React from 'react';
import * as cx from 'classnames';

export interface Props {
  done?: boolean;
  active?: boolean;
  title?: React.ReactNode | string;
  children?: React.ReactNode;
  showTitle?: boolean;
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  titlePosition?: string;
}

const ProcessIndicatorItem: React.SFC<Props> = ({
  done = false,
  title = '',
  active = false,
  children = null,
  showTitle = true,
  className = '',
  iconClassName = '',
  titleClassName = '',
  titlePosition = 'bottom',
}) => {
  const classes = cx(
    'process-indicator__item',
    {
      'process-indicator__item--active': active,
      'process-indicator__item--done': done,
    },
    className,
  );

  return (
    <div className={classes}>
      <div className={cx('process-indicator__icon', iconClassName)}>
        {children}
      </div>
      {showTitle && (
        <div
          className={cx(
            'process-indicator__title',
            {
              [`process-indicator__title--${titlePosition}`]: Boolean(
                titlePosition,
              ),
            },
            titleClassName,
          )}
        >
          {title}
        </div>
      )}
    </div>
  );
};

export default ProcessIndicatorItem;
